<!-- Custom Actions Start -->
<div class="list-custom-actions">
  @if (options?.customActions?.length && !service.selectedItems.length) {
    @for (action of options?.customActions; track action) {
      @switch (action?.type) {
        @case (undefined) {
          @if (!action?.hideFn || (action?.hideFn && !action?.hideFn(row))) {
            @if (action?.showPermission) {
              <button
                mat-icon-button
                color="primary"
                fxFlex="nogrow"
                fxLayoutAlign="center center"
                [class.disabled]="action?.disableFn ? action?.disableFn(row) : false"
                [disabled]="action?.disableFn ? action?.disableFn(row) : false"
                [ngClass]="action?.cssClass"
                [matTooltip]="action?.tooltip?.translate ? (action?.tooltip?.text | translate) : action?.tooltip?.text"
                (click)="action?.fn(row)"
              >
                @if (action?.icon) {
                  @if (action?.icon?.svgIcon) {
                    <mat-icon class="mdi-icon icon-border" [svgIcon]="action?.icon?.name" [attr.size]="'14px'">
                    </mat-icon>
                  } @else {
                    <mat-icon>{{ action?.icon?.name }}</mat-icon>
                  }
                }

                @if (action?.title?.name) {
                  <span>
                    {{ action?.title?.translate ? (action?.title?.name | translate) : action?.title?.name }}
                  </span>
                }
              </button>
            }
          }
        }

        @case ('toggle') {
          @if (!action?.hideFn || (action?.hideFn && !action?.hideFn(row))) {
            <mat-slide-toggle
              fxFlex="nogrow"
              fxLayoutAlign="center center"
              color="primary"
              [class.disabled]="action?.disableFn ? action?.disableFn(row) : false"
              [disabled]="action?.disableFn ? action?.disableFn(row) : false"
              [ngClass]="action?.cssClass"
              [matTooltip]="action?.tooltip?.translate ? (action?.tooltip?.text | translate) : action?.tooltip?.text"
              (click)="
                action?.fn
                  ? action?.fn(row)
                  : service.toggleKey(
                      row?.id,
                      action?.toggleOptions?.key,
                      service?.getValue(row, action?.toggleOptions?.key)
                    )
              "
              [checked]="!!service?.getValue(row, action?.toggleOptions?.key)"
            >
              @if (action?.title?.name) {
                <span>
                  {{ action?.title?.translate ? (action?.title?.name | translate) : action?.title?.name }}
                </span>
              }
            </mat-slide-toggle>
          }
        }

        <!-- Dropdown action -->
        @case ('dropdown') {
          @if (!action?.hideFn || (action?.hideFn && !action?.hideFn(row))) {
            @if (action?.dropdownActions?.length && (hasPermission || rolesPermissionsService.getIsAdmin())) {
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                fxFlex="nogrow"
                fxLayoutAlign="center center"
                [class.disabled]="action?.disableFn ? action?.disableFn(row) : false"
                [disabled]="action?.disableFn ? action?.disableFn(row) : false"
                [ngClass]="action?.cssClass"
                [matTooltip]="action?.tooltip?.translate ? (action?.tooltip?.text | translate) : action?.tooltip?.text"
                class="settings-dropdown-btn"
                fxLayout="row"
              >
                <mat-icon class="mdi-icon" [svgIcon]="'dots-vertical'"></mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                @for (dropdownAction of action?.dropdownActions; track dropdownAction) {
                  <ng-template
                    [ngTemplateOutlet]="actionTemplateRef"
                    [ngTemplateOutletContext]="{ action: dropdownAction }"
                  >
                  </ng-template>
                }
              </mat-menu>
            }
          }
        }
      }
    }
  }
</div>
<!-- Custom Actions End -->

<!-- Start Single Action Template -->
<ng-template #actionTemplateRef let-action="action">
  @if ((!action?.hideFn || (action?.hideFn && !action?.hideFn(row))) && action?.showPermission) {
    <button
      mat-menu-item
      [disabled]="action?.disableFn ? action?.disableFn(row) : false"
      [ngClass]="action?.cssClass"
      (click)="action?.fn(row)"
    >
      @if (action?.icon) {
        @if (action?.icon?.svgIcon) {
          <mat-icon class="mdi-icon" [svgIcon]="action?.icon?.name" [attr.size]="'20px'"></mat-icon>
        } @else {
          <mat-icon>{{ action?.icon?.name }}</mat-icon>
        }
      }

      @if (action?.title?.name) {
        <span>
          {{ action?.title?.translate ? (action?.title?.name | translate) : action?.title?.name }}
        </span>
      }
    </button>
  }
</ng-template>
<!-- End Single Action Template -->
